import styled from 'styled-components';

const ItemDivider = styled.div`
    height: 0;
    margin: 2px 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
`;

export default ItemDivider;
